import { render, staticRenderFns } from "./BaseTooltipIconMultiple.vue?vue&type=template&id=57989074"
import script from "./BaseTooltipIconMultiple.vue?vue&type=script&lang=js"
export * from "./BaseTooltipIconMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports